import { theme } from '../../../global-styles';
import styled, { css } from 'styled-components';

export const ReservationPolicyWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  .wrapper {
    background-color: ${theme.colours.white};
    width: 714px;
    max-width: 714px;
    padding: 20px;
    border-radius: 12px;
    @media (max-width: 767px) {
      width: 100% !important;
      max-width: 100% !important;
    }
  }
  .backBtn {
    font-size: 13px;
    font-weight: 400;
    line-height: 17px;
    font-family: ${theme.fonts.Regular};
    color: #0c58db;
    cursor: pointer;
    .backIcon {
      height: 17px;
    }
  }
  h2 {
    font-size: 16px;
    font-weight: 600;
    line-height: 27.39px;
    font-family: ${theme.fonts.SemiBold};
    color: #000000;
  }
  p {
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    font-family: ${theme.fonts.Regular};
    color: #000000;
    margin-top: 20px;
  }
  p.firstParagraph {
    margin-top: 0px;
  }
`;
